import useApp from '@/composables/useApp'
const { logOut } = useApp()
import emitter from '@/eventBus';
import axios from '@/axios'



export default {

  getPushToken({ dispatch, commit, state }, payload) {
    if (localStorage.getItem("push")) {
      commit("setPushToken", JSON.parse(localStorage.getItem("push")))
    }
  },

  readToken({ dispatch, commit, state }, payload) {
    let auth = null;
    auth = JSON.parse(localStorage.getItem("auth"));
    //saving auth in state
    commit("setAuth", auth);
  },

  getDevices({ dispatch, commit, state }, payload) {
    const axiosHeader = {
      headers: {
        token: state.auth.token
      }
    };

    axios.get("/device", axiosHeader)
      .then(res => {
        //console.log(res.data.data);

        res.data.data.forEach((device, index) => {
          if (device.selected) {
            commit("setSelectedDevice", device);
            emitter.emit('selectedDeviceIndex', index);
          }
        });

        //if all devices were removed
        if (res.data.data.length == 0) {
          commit("setSelectedDevice", {});
          emitter.emit('selectedDeviceIndex', null);
          //$nuxt.$emit('selectedDeviceIndex', null);
        }

        commit("setDevices", res.data.data);


      }).catch(error => {
        console.log(error);
        logOut()
      });

  },

  getNotifications({ dispatch, commit, state }, payload) {
    const axiosHeader = {
      headers: {
        token: state.auth.token
      }
    };

    axios.get("/notifications", axiosHeader)
      .then(res => {
        commit("setNotifications", res.data.data)
        res.data.data.some((e) => !e.readed) ? commit("setNewNotificationStatus", true) :
          commit("setNewNotificationStatus", false)

      }).catch(error => {
        //console.log(error);
      });

  },

  getDashStyle({ dispatch, commit, state }, payload) {
    if (localStorage.getItem("dashStyle")) {
      commit("setDashboardStyle", JSON.parse(localStorage.getItem("dashStyle")))
    } else {
      commit("setDashboardStyle", null)
    }

  }



};


